import { truckApi } from "./truck.api";

export const {
  useGetTrucksQuery,
  useLazySearchTrucksQuery,
  useGetTruckQuery,
  useLazyGetTruckQuery,
  useLazyGetIsTruckQuery,
  useRebindTruckMutation,
  useCreateTruckMutation,
  useDeleteTruckMutation,
  useListTrucksInfiniteQuery,
  useGetTruckShippingFiltersQuery
} = truckApi;
